import { useState } from 'react';

export const useConfirm = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [config, setConfig] = useState({
    title: '',
    message: '',
    onConfirm: () => {},
    confirmText: 'Confirm',
    cancelText: 'Cancel',
    type: 'warning'
  });

  const confirm = ({ title, message, onConfirm, confirmText = 'Confirm', cancelText = 'Cancel', type = 'warning' }) => {
    return new Promise((resolve) => {
      setConfig({
        title,
        message,
        onConfirm: () => {
          onConfirm?.();
          resolve(true);
        },
        confirmText,
        cancelText,
        type
      });
      setIsOpen(true);
    });
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  return {
    isOpen,
    config,
    confirm,
    handleClose
  };
};
